import {formatDistanceToNow} from 'date-fns';

export const formatRelativeTime = (date?: Date | string): string => {
  if (date == null) {
    return '';
  }
  const parsed = typeof date === 'string' ? new Date(date) : date;
  if (Number.isNaN(parsed.getTime())) {
    return '';
  }
  return formatDistanceToNow(parsed, {addSuffix: true});
};
